import { useState, useCallback, useRef } from "react";

export function useHistory(init) {
  const [past, setPast]     = useState([]);
  const [state, setState]   = useState(init);
  const [future, setFuture] = useState([]);
  const preRef = useRef(null);

  const commit = useCallback(fn =>
    setState(prev => {
      const next = typeof fn === "function" ? fn(prev) : fn;
      setPast(p => [...p.slice(-60), prev]);
      setFuture([]);
      return next;
    }), []);

  const beginDrag = useCallback(() =>
    setState(prev => { preRef.current = prev; return prev; }), []);

  const commitDrag = useCallback(fn => {
    if (!preRef.current) return;
    const pre = preRef.current; preRef.current = null;
    setState(() => {
      const next = fn(pre);
      setPast(p => [...p.slice(-60), pre]);
      setFuture([]);
      return next;
    });
  }, []);

  const undo = useCallback(() =>
    setPast(p => {
      if (!p.length) return p;
      setFuture(f => [state, ...f]);
      setState(p[p.length - 1]);
      return p.slice(0, -1);
    }), [state]);

  const redo = useCallback(() =>
    setFuture(f => {
      if (!f.length) return f;
      setPast(p => [...p, state]);
      setState(f[0]);
      return f.slice(1);
    }), [state]);

  return { state, commit, beginDrag, commitDrag, undo, redo, canUndo: past.length > 0, canRedo: future.length > 0 };
}
